import { ColorableSVG } from "../ColorableSVG";
import { AssembleIconProps } from "../types";

export const RulesIcon = ({
  height = "16px",
  width = "16px",
  ...props
}: AssembleIconProps): JSX.Element => (
  <ColorableSVG {...props}>
    <svg
      aria-label="Rules"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke"
        d="M6.5 2.5L3.16667 5.83333L1.5 4.16667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M1.5 9.5L5.5 13.5"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M5.5 9.5L1.5 13.5"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        className="stroke"
        d="M9.5 11.5H14.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M9.5 4.5H14.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </ColorableSVG>
);
